<div class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
  @if (showTypes) {
    <div
      class="tags mt-6"
      animate.enter="pop-in-enter"
      animate.leave="pop-in-leave"
    >
      @for (tableType of tableTypes; track $index) {
        <span
          [ngClass]="tableType.color"
          (click)="addNewTable(tableType.name)"
          class="tag has-click is-medium is-hoverable has-text-weight-bold is-rounded"
          >{{ tableType.name + '.title' | translate }}</span
        >
      }
    </div>
  }

  <button fino-button type="button" (click)="toggleTypes()" class="mb-4 ml-2 is-fullwidth mt-6">
    <fino-icon icon="Add"></fino-icon>
  </button>
</div>
